module.exports = __webpack_public_path__ + "static/media/icon-supporters-2.db008867.svg";